import React, { Component, Fragment } from 'react';
import {
  Container,
  Row, Col, Input, Button, Form, FormGroup
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faTimes, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import ConfirmButton from '../Modal/ConfirmButton';
class SalesOpportunitiesTags extends Component {

  standardRow = (opportunitiesTag) => {
    return (
      <Row className="adminRow pointer text-left" onClick={() => this.props.onEdit(opportunitiesTag.ID)}>
        <Col md={4}>{opportunitiesTag.Tag}</Col>
        <Col md={4}>{opportunitiesTag.PrimaryCategory ? 'Primary Category' : ''}</Col>
        <Col md={4}>{opportunitiesTag.FilterChecked ? 'Filter Checked by Default' : ''}</Col>
      </Row>
    )
  }

  editRow = (opportunitiesTag) => {
    return (
      <Row className="editRow adminRow">
        <Col md={8} className="text-left">
          <Form inline>
            <FormGroup className="mr-2">
              <Input
                placeholder="Opportunity Tag"
                name="tag"
                value={this.props.editOpportunitiesTag.tag + ''}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="mr-2">
              <Input
                placeholder="Order"
                type="number"
                min="0"
                name="order"
                value={this.props.editOpportunitiesTag.order}
                onChange={e => this.props.onChange(e, 'edit')} />
            </FormGroup>
            <FormGroup className="mr-2">
              <Input
                type="checkbox"
                name="primaryCategory"
                checked={this.props.editOpportunitiesTag.primaryCategory}
                onChange={e => this.props.onChange(e, 'edit')} />
              Primary Category
            </FormGroup>
            <FormGroup className="mr-2">
              <Input
                type="checkbox"
                name="filterChecked"
                checked={this.props.editOpportunitiesTag.filterChecked}
                onChange={e => this.props.onChange(e, 'edit')} />
              Filter Checked by Default
            </FormGroup>
          </Form>
        </Col>
        <Col md={4} className="text-right">
          <Button className="mx-1" color="success" onClick={this.props.handleEdit} title="Edit Opportunity Tag">
            <FontAwesomeIcon icon={faCheck} />
          </Button>
          <ConfirmButton className="mx-3" color="danger" onClick={() => this.props.onDelete(opportunitiesTag.ID)} edit="Delete Opportunity Tag">
            <FontAwesomeIcon icon={faTrashAlt} />
          </ConfirmButton>
          <Button className="mx-1" color="secondary" onClick={this.props.handleCancel} title="Cancel">
            <FontAwesomeIcon icon={faTimes} />
          </Button>
        </Col>
      </Row>
    )
  }

  addRow = () => {
    return (<Row className="py-4 text-left align-items-bottom">
      <Col md={8}>
        <Form inline>
          <FormGroup className="mr-2">
            Add New Opportunity Tag
          </FormGroup>
          <FormGroup className="mr-2">
            <Input
              placeholder="Opportunity Tag"
              name="tag"
              value={this.props.newOpportunitiesTag.tag + ''}
              onChange={e => this.props.onChange(e)} />
          </FormGroup>
          <FormGroup className="mr-2">
            <Input
              placeholder="Order"
              type="number"
              name="order"
              min="0"
              value={this.props.newOpportunitiesTag.order}
              onChange={e => this.props.onChange(e)} />
          </FormGroup>
          <FormGroup className="mr-2">
            <Input
              type="checkbox"
              name="primaryCategory"
              checked={this.props.newOpportunitiesTag.primaryCategory}
              onChange={e => this.props.onChange(e)} />
            Primary Category
          </FormGroup>
          <FormGroup className="mr-2">
            <Input
              type="checkbox"
              name="filterChecked"
              checked={this.props.newOpportunitiesTag.filterChecked}
              onChange={e => this.props.onChange(e)} />
            Filter Checked by Default
          </FormGroup>
        </Form>
      </Col>
      <Col md={4} className="text-right">
        <Button
          disabled={this.props.newOpportunitiesTag.tag === ''}
          color="primary"
          onClick={this.props.handleAdd}>
          Add Opportunity Tag
        </Button>
      </Col>
    </Row>
    )
  }

  render() {
    return (
      <Container className="adminContainer" fluid>
        {this.props.opportunitiesTags.map(opportunitiesTag => (
          <Fragment key={opportunitiesTag.ID}>{this.props.editOpportunitiesTag.id === opportunitiesTag.ID ? this.editRow(opportunitiesTag) : this.standardRow(opportunitiesTag)}</Fragment>
        ))}
        {this.addRow()}
      </Container>
    );
  }
}

export default SalesOpportunitiesTags;
